import { render } from "./form.vue?vue&type=template&id=56aab58c&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=56aab58c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-56aab58c"

export default script